import api from './api';

const guaranteeShiftApi = api.injectEndpoints({
	endpoints: (build) => ({
		guarantee: build.mutation({
			query: ({ shiftId, body }) => ({
				url: `/shifts/${shiftId}/slots/guaranteed`,
				method: 'PUT',
				body
			}),
			invalidatesTags: ['GlobalOverviewShifts']
		}),
		guaranteeBundle: build.mutation({
			query: ({ contractId, body }) => ({
				url: `/bundles/${contractId}/guaranteed`,
				method: 'PUT',
				body
			}),
			invalidatesTags: ['GlobalOverviewShifts']
		}),
		getAvailableBundleSlots: build.mutation({
			query: (contractId) => ({
				url: `/bundles/${contractId}/slots`,
				method: 'GET'
			})
		})
	})
});

export const { useGuaranteeMutation } = guaranteeShiftApi;
export const { useGuaranteeBundleMutation } = guaranteeShiftApi;
export const { useGetAvailableBundleSlotsMutation } = guaranteeShiftApi;
export default guaranteeShiftApi;
